import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { useDispatch } from 'react-redux';
import { Box } from '@famly/mf_layout_box';
import { checkInChild } from 'signin-app/child/check-in/actions';
import * as ChildCheckinSelectors from 'signin-app/child/check-in/selectors';
import { pinHolder } from 'signin-app/pin/selectors';
import translate from 'signin-app/helpers/translate';
import PersonButton from 'signin-app/components/person-button';
import { ConfirmButton, ActionButton as CancelButton, BottomBarContainer, PageBodyContainer, } from 'signin-app/components/action-buttons';
import { selectGoHomeWithChild } from 'signin-app/go-home-with/actions';
import { getPinChild } from 'signin-app/child/selectors';
import useTypedSelector from 'signin-app/components/hooks/use-typed-selector';
import { GroupGrid } from 'signin-app/components/group-grid';
import { useDisplayName } from 'signin-app/helpers/use-display-name';
import * as Selectors from './selectors';
const Children = (props) => {
    const { match } = props;
    const groups = useTypedSelector(Selectors.groups);
    const selectedGoHomeWithChildId = useTypedSelector(Selectors.selectedGoHomeWithChildId);
    const isCheckingIn = useTypedSelector(ChildCheckinSelectors.isCheckingIn);
    const pin = useTypedSelector(pinHolder);
    const selectedChild = useTypedSelector(state => getPinChild(state, { childId: props.childId }));
    const displayName = useDisplayName(selectedChild === null || selectedChild === void 0 ? void 0 : selectedChild.name.firstName, selectedChild === null || selectedChild === void 0 ? void 0 : selectedChild.name.lastName);
    const selectedGroup = groups.find(group => group.groupId === match.params.groupId);
    const dispatch = useDispatch();
    React.useEffect(() => {
        dispatch(selectGoHomeWithChild.action(''));
    }, [dispatch]);
    const handleChildCheckin = React.useCallback(() => {
        if (!selectedChild) {
            return;
        }
        const successMessage = translate('signInSuccess', {
            personName: displayName,
        });
        dispatch(checkInChild.action({
            childId: selectedChild.id,
            successMessage,
            pin,
            goHomeWithChildId: selectedGoHomeWithChildId,
        }));
    }, [selectedChild, dispatch, selectedGoHomeWithChildId, pin, displayName]);
    return (_jsxs(Box, { children: [_jsx(PageBodyContainer, { children: _jsx(GroupGrid, { children: selectedGroup
                        ? selectedGroup.children.map(child => (_jsx(PersonButton, { person: child, onClick: selectGoHomeWithChild.dispatch, selected: selectedGoHomeWithChildId === child.childId }, child.childId)))
                        : null }) }), _jsxs(BottomBarContainer, { children: [_jsx(CancelButton, { text: translate('cancel'), link: "/pin" }), _jsx(ConfirmButton, { type: 'signIn', isLoading: isCheckingIn, onClick: handleChildCheckin, text: translate('signIn', { personName: displayName }), disabled: !selectedGoHomeWithChildId, dataE2EId: "go-home-with-confirm-button" })] })] }));
};
export default Children;
